// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Qb2_B","footer":"styles_footer__2UzrB"};